var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11,
    stroke: "#42a816",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71224 14.7948L7.21001 12.2899C6.93119 12.0107 6.48794 12.0107 6.20912 12.2899C5.93029 12.569 5.93029 13.0127 6.20912 13.2918L9.20465 16.2907C9.48347 16.5698 9.93387 16.5698 10.2127 16.2907L17.7909 8.71133C18.0697 8.43221 18.0697 7.98847 17.7909 7.70934C17.5121 7.43022 17.0688 7.43022 16.79 7.70934L9.71224 14.7948Z",
    fill: "#42a816",
    stroke: "#42a816"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.8a523a248b588271169003f75d880626.svg";
export { ForwardRef as ReactComponent };